import { Navigate, Outlet } from 'react-router';
import { usePermissions } from '@/hooks/use-permissions';
import type { UserRole } from '@/types';

export function RequireRole({ minRole }: { minRole: UserRole }) {
  const { hasMinRole } = usePermissions();

  if (!hasMinRole(minRole)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
